// Dependencies
import { createGlobalStyle } from 'styled-components';

const ButtonStyles = createGlobalStyle`
button {
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: 0;
  box-shadow: none;
  background-color: transparent;

  &:focus,
  &:focus-within {
    border: none;
    outline: none;
  }
}

.btn {
  display: inline-block;
  min-width: 8rem;
  padding: 1rem 1.5rem;
  font-size: 0.875rem;
  letter-spacing: 0.05rem;
  line-height: 1.3;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  word-break: break-word;
  color: var(--color-charcoal);
  background-color: #fff;
  box-shadow: -3px -3px 14px -5px rgba(0, 0, 0, 0.1);
  transition: color 0.4s, background-color 0.4s, border-color 0.4s;

  &:hover,
  &:focus {
    background-color: var(--color-sand);
  }

  &.dark {
    color: #fff;
    background-color: var(--color-charcoal);

    &:hover,
    &:focus {
      background-color: var(--color-graphite);
    }
  }

  &.text-only {
    min-width: 0;
    margin: 0;
    padding: 0;
    font-size: 0.813rem;
    box-shadow: none;
    background-color: transparent;

    &.underline {
      border-bottom: 1px solid var(--color-charcoal);
    }

    &:hover,
    &:focus {
      background-color: transparent;
      color: #000;

      &.underline {
        border-color: var(--color-graphite);
      }
    }
  }

  &.location {
    width: 100%;
    min-width: 0;
    padding: 0.75rem 0.5rem;
    font-size: 0.813rem;
    font-weight: var(--font-weight-medium);
    color: var(--color-bark);
    border: 0.063rem solid var(--color-swiss-coffee);
    background-color: #fff;

    &:hover,
    &:focus {
      color: var(--color-charcoal);
    }
  }

  &.large {
    min-width: 17.5rem;
  }

  &.small {
    min-width: 6rem;
    padding: 0.8rem 1.3rem;
    font-size: 0.8rem;
    letter-spacing: 0.06rem;
  }

  &.full-width {
    width: 100%;
  }

  &.no-shadow {
    box-shadow: none;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media(min-width: 500px) {
    min-width: 9.375rem;
    padding: 1.25rem 1.5rem;

    &.location {
      padding: 1.25rem 1.5rem;
    }

    &.small {
      min-width: 8rem;
      padding: 1.1rem 1.3rem;
    }
  }

  @media(min-width: 768px) {
    min-width: 7rem;
    font-size: 1rem;

    &.border {
      font-size: 1.063rem;
    }

    &.location {
      min-width: 0;
    }

    &.small {
      font-size: 0.8rem;
    }
  }

  @media(min-width: 992px) {
    min-width: 9.5rem;

    &.small {
      min-width: 8.5rem;
    }
  }

  @media(min-width: 1200px) {
    min-width: 10.625rem;

    &.small {
      min-width: 9rem;
    }
  }
}

.btn-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  grid-gap: 1rem;

  @media(min-width: 400px) {
    grid-gap: 1.75rem;
  }

  @media(min-width: 768px) {
    grid-gap: 1rem;

    .btn {
      padding: 1.25rem 1.875rem;
    }
  }

  @media(min-width: 992px) {
    grid-gap: 1.5rem;
  }

  @media(min-width: 1200px) {
    grid-gap: 2rem;
  }

  @media(min-width: 1400px) {
    grid-gap: 3rem;
  }
}
`;

export default ButtonStyles;
